/* ===== Prize Editor ===== */
import { escapeHtml } from '../utils/helpers.js?v=83.58';
import { getCurrentSettings } from '../services/settings.js?v=83.58';
import { sanitizeImageSrc } from '../utils/url.js?v=83.58';

export function addPrizeOption(p = {}) {
  const wrap = document.createElement('div');
  wrap.className = 'prize-card';

  /* ✅ SECURITY FIX: Escaping content */
  const safeMsg = escapeHtml(p.message || '');
  const count = parseInt(p.count || 0);

  // XSS-safe rendering: Use placeholder slot instead of injecting URL into template
  const imgPreviewSlot = p.image
    ? '<div class="prize-img-slot"></div>'
    : `<div class="prize-placeholder">
        <span class="prize-placeholder-text">Fără poză</span>
       </div>`;

  wrap.innerHTML = `
    <div class="prize-card-header">
      <div class="prize-card-preview">
        ${imgPreviewSlot}
      </div>
      <label class="prize-count-wrap"><span>Bucăți</span><input class="prizeCount small" type="number" placeholder="0" value="${count}" min="0" title="Număr de recompense disponibile"/></label>
      <button type="button" class="btn-delete-prize" title="Șterge recompensa" aria-label="Șterge recompensa"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/></svg></button>
    </div>
    <div class="prize-card-body">
      <label>Mesaj recompensă</label>
      <textarea class="prizeMsg" placeholder="Mesaj recompensă">${safeMsg}</textarea>
      <label>Imagine recompensă</label>
      <input class="prizeImg small" type="file" accept="image/*"/>
    </div>
  `;

  const deleteBtn = wrap.querySelector('.btn-delete-prize');
  if (deleteBtn) {
    deleteBtn.addEventListener('click', () => {
      wrap.remove();
    });
  }
  
  // XSS-safe rendering: Fill image slot using DOM API with sanitized URL
  if (p.image) {
    const slot = wrap.querySelector('.prize-img-slot');
    if (slot) {
      const safeUrl = sanitizeImageSrc(p.image);
      if (safeUrl) {
        const img = document.createElement('img');
        img.className = 'prize-mini';
        img.src = safeUrl;
        img.setAttribute('data-src', safeUrl);
        img.alt = 'prize';
        slot.appendChild(img);
      } else {
        // Fallback to placeholder if URL is invalid
        // XSS-safe rendering: Use DOM API instead of outerHTML
        
        const ph = document.createElement('div');
        ph.className = 'prize-placeholder';

        const icon = document.createElement('span');
        icon.className = 'prize-placeholder-icon';
        icon.textContent = '🖼️';

        const text = document.createElement('span');
        text.className = 'prize-placeholder-text';
        text.textContent = 'Fără imagine';

        ph.append(icon, text);
        slot.replaceWith(ph);
      }
    }
  }
  
  document.getElementById('prizeContainer').appendChild(wrap);
}

export function renderPrizeOptions() {
  const currentSettings = getCurrentSettings();
  const cont = document.getElementById('prizeContainer');
  if (!cont) return;
  
  cont.innerHTML = '';
  if (currentSettings?.prizes?.length) {
    currentSettings.prizes.forEach(addPrizeOption);
  } else {
    addPrizeOption();
    addPrizeOption();
  }
}

// Make available globally for onclick handlers
window.addPrizeOption = addPrizeOption;
